import { render } from "./Paladin.vue?vue&type=template&id=5bc8d2c1&scoped=true"
import script from "./Paladin.vue?vue&type=script&lang=js"
export * from "./Paladin.vue?vue&type=script&lang=js"

import "./Paladin.vue?vue&type=style&index=0&id=5bc8d2c1&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\website_tow\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc8d2c1"]])

export default __exports__